import { VStack } from "@chakra-ui/react";
import experience from "../../files/experience.json";
import { ExperienceCard } from "./ExperienceCard";

export const ExperienceGrid = () => (
  <VStack align="stretch" spacing={4}>
    {experience.map((job) => (
      <ExperienceCard key={`${job.company}-${job.dates}`} job={job} />
    ))}
  </VStack>
);
